<template>
  <div class="full-spinner d-flex justify-content-center align-items-center">
    <mdb-spinner big color="blue" />
  </div>
</template>

<script>

// libraries
import { mapActions } from 'vuex'

export default {
  name: 'Confirmation',
  methods: {
    ...mapActions({
      confirmation: 'auth/confirmation'
    })
  },
  async created() {
    await this.confirmation({
      confirmation_token: this.$route.query.token,
      reconfirmation: !!this.$route.query.reconfirmation
    })
    this.$router.push({ name: 'top' })
  }
}
</script>

<style scoped lang="scss">
.full-spinner {
  width: 100vw;
  height: 100vh;
}
</style>
